import { DecimalPipe } from '@angular/common';
import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import { UserProfileService } from '@polaris-customerweb/sharedcomponents.user-profile';
import { firstValueFrom } from 'rxjs';
import { AreaDisplayService } from 'src/app/state/shared/services/area-display.service';

@Component({
    imports: [DecimalPipe],
    selector: 'rdx-area-display',
    styleUrls: ['./area-display.component.scss'],
    templateUrl: './area-display.component.html',
})
export class AreaDisplayComponent implements OnChanges, OnInit {
    @Input() areaInMeters: number;

    isMetric = false;
    area: string;
    units: string;
    invalid = false;

    constructor(
        private areaDisplayService: AreaDisplayService,
        private profileService: UserProfileService
    ) {}

    ngOnInit(): void {
        void firstValueFrom(this.profileService.getIsMetric$()).then(
            (isMetric) => {
                this.isMetric = isMetric;
                this.getMeasurementFormat();
            }
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (changes.areaInMeters) {
            this.getMeasurementFormat();
        }
    }

    getMeasurementFormat(): void {
        const { isValid, value, units } =
            this.areaDisplayService.getMeasurementFormat(
                this.areaInMeters,
                this.isMetric
            );
        this.area = value;
        this.units = units;
        this.invalid = !isValid;
    }
}
